import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import usePresentations from '../hooks/usePresentations';

const trackClick = (action) => {
    if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'investor_cta_click', action });
    }
};

const HeroSection = () => {
    const { presentationUrl, factsheetUrl } = usePresentations();

    return (
        <div className="hero-section">
            <div className="video-container">
                <img
                    src="/images/hero.avif"
                    className="background-video"
                    alt=""
                />
                <div className="hero-overlay"></div>
                    

                <div className="content-overlay">
                    <Container className="d-flex flex-column align-items-center text-white">
                        <Row className="justify-content-between align-items-center w-100">
                            <Col md={7}>
                                <h2 className="animate__animated animate__slideInUp">
                                    North America's Next Tier-One <span className="gold">Gold Developer</span>
                                </h2>

                                <h6 className="animate__animated animate__slideInUp pt-md-5 hero-width">
                                    Q-Gold Resources is advancing a dual-asset gold platform focused on near-term growth and domestic gold production. With a transformational U.S. acquisition in Oregon and a high-grade, drill-ready project in Ontario, Q-Gold is positioned to become America's next Tier-One gold developer.
                                </h6>

                                <div className="hero-cta-row animate__animated animate__slideInUp hero-width">
                                    <a
                                        href={presentationUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => trackClick('cta_corporate_presentation_hero')}
                                        className="hero-cta hero-cta--primary"
                                    >
                                        <i className="fas fa-file-pdf" aria-hidden="true" />
                                        <span>View Corporate Presentation</span>
                                    </a>
                                    <a
                                        href={factsheetUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => trackClick('cta_fact_sheet_hero')}
                                        className="hero-cta hero-cta--secondary"
                                    >
                                        <i className="fas fa-download" aria-hidden="true" />
                                        <span>Download Fact Sheet</span>
                                    </a>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
